import { FormattedMessage } from 'react-intl'
import Flex from 'styled-flex-component'

import { useCampaignMenuActions } from '@components/Campaign/Menu'
import Breakpoint from '@components/UI/Breakpoint'
import Theme from '@theme'
import { Button, Container, Text } from '@tribegroup'
import { ActionIconWrapper } from '../TitleBar.styled'
export const InboxTitleBardDownloadInstagramHandlesAction: React.FC = () => {
  const { onDownloadInstagramHandles, hasDownloadInstagramHandles } = useCampaignMenuActions()

  if (!hasDownloadInstagramHandles) {
    return null
  }

  return (
    <ActionIconWrapper>
      <Breakpoint desktop>
        <Container height={2.5} rightOuterSpacing={0.5}>
          <Flex center full>
            <Button
              outlined
              height={1.75}
              small
              noUppercase
              noFocus
              topInnerSpacing={0}
              bottomInnerSpacing={0}
              leftInnerSpacing={1.25}
              rightInnerSpacing={1.25}
              onClick={onDownloadInstagramHandles}
            >
              <Text color={Theme.grey900Color} customFontSize={0.8125}>
                <FormattedMessage id="inbox.titlebar.action.downloadInstagramHandles" />
              </Text>
            </Button>
          </Flex>
        </Container>
      </Breakpoint>
    </ActionIconWrapper>
  )
}
